export { default } from './DynamicStarfield';
